import { TableWrapper } from '@4beefopag/4bee-fopag-core/dist/atoms';
import { Table } from 'antd';
import PropTypes from 'prop-types';
import * as R from 'ramda';
import React from 'react';
import styled from 'styled-components';
import usePagination from '../../../hooks/usePagination';
import { Input } from '../../atoms/Apontamento';
import PageSizeOption from '../../molecules/PageSizeOption';
import TableFooter from './TableFooter';

const Wrapper = styled(TableWrapper)`
  background-color: white;

  .ant-table-footer {
    padding: 0px;
    background: white;
  }
`;

const InputFullCol = styled(Input)`
  width: 100%;
`;

function BenefitOrderTable({ cooperators, onChangeCooperatorValue, isEditable, buttons }) {
  const { currentPage, goToPage, pageSize, updatePageSize } = usePagination(8);

  const columns = [
    {
      title: 'CPF',
      filters: cooperators.map((cooperatorOrder) => ({
        text: cooperatorOrder.cooperator.cpf,
        value: cooperatorOrder.cooperator.cpf,
      })),
      render: (_, item) => item.cooperator.cpf,
      onFilter: (value, item) => item.cooperator.cpf === value,
      sorter: (cooperatorOrder1, cooperatorOrder2) => cooperatorOrder1.cooperator.cpf > cooperatorOrder2.cooperator.cpf,
    },
    {
      title: 'ID Cooperado',
      filters: cooperators.map((cooperatorOrder) => ({
        text: cooperatorOrder.cooperator.id,
        value: cooperatorOrder.cooperator.id,
      })),
      render: (_, item) => item.cooperator.id,
      onFilter: (value, item) => item.cooperator.id === value,
      sorter: (cooperatorOrder1, cooperatorOrder2) => cooperatorOrder1.cooperator.id > cooperatorOrder2.cooperator.id,
    },
    {
      title: 'Nome',
      filters: cooperators.map((cooperatorOrder) => ({
        text: cooperatorOrder.cooperator.name,
        value: cooperatorOrder.cooperator.name,
      })),
      render: (_, item) => item.cooperator.name,
      onFilter: (value, item) => item.cooperator.name === value,
      sorter: (cooperatorOrder1, cooperatorOrder2) =>
        cooperatorOrder1.cooperator.name > cooperatorOrder2.cooperator.name,
    },
    {
      title: 'Situação',
      dataIndex: 'situationDescription',
      filters: R.uniqBy(
        R.prop('value'),
        cooperators.map(({ situationDescription }) => ({
          text: situationDescription,
          value: situationDescription,
        }))
      ),
      onFilter: (value, item) => item.situationDescription === value,
      sorter: (cooperatorOrder1, cooperatorOrder2) =>
        cooperatorOrder1.situationDescription
          .toLowerCase()
          .localeCompare(cooperatorOrder2.situationDescription.toLowerCase()),
    },
    {
      title: 'VA / Período',
      width: '200px',
      render: (_, item) => (
        <InputFullCol
          disabled={!isEditable}
          min={0}
          prefix="R$"
          value={item.foodVoucherValue}
          getValue={(newValue) => onChangeCooperatorValue(item.cooperator.id, 'foodVoucherValue', newValue)}
        />
      ),
    },
    {
      title: 'VR / Período',
      width: '200px',
      render: (_, item) => (
        <InputFullCol
          disabled={!isEditable}
          min={0}
          prefix="R$"
          value={item.mealVoucherValue}
          getValue={(newValue) => onChangeCooperatorValue(item.cooperator.id, 'mealVoucherValue', newValue)}
        />
      ),
    },
  ];

  return (
    <Wrapper>
      <PageSizeOption
        label="Exibir cooperados por página:"
        total={cooperators.length}
        pageSize={pageSize}
        onChangePageSize={updatePageSize}
      />
      <Table
        columns={columns}
        dataSource={cooperators}
        pagination={{
          current: currentPage,
          total: cooperators.length,
          style: { display: 'none' }, // feito para funcionar a paginação, so que é controlada por fora
          pageSize,
        }}
        footer={(pageData) => (
          <TableFooter
            pageData={pageData}
            buttons={buttons}
            page={currentPage}
            onChange={goToPage}
            total={cooperators.length}
            totalPerPage={pageSize}
            onChangeTotalPerPage={updatePageSize}
          />
        )}
      />
    </Wrapper>
  );
}

BenefitOrderTable.propTypes = {
  cooperators: PropTypes.arrayOf(),
  onChangeCooperatorValue: PropTypes.func.isRequired,
  isEditable: PropTypes.bool.isRequired,
  buttons: PropTypes.element.isRequired,
};

BenefitOrderTable.defaultProps = {
  cooperators: [],
};

export default BenefitOrderTable;
